import React, { useState } from 'react';
import { getStringValue } from '../utils/blockHelpers';

const TeamComparisonDisplay = ({ block }) => {
  const t1Stats = block.team1_stats || {};
  const t2Stats = block.team2_stats || {};
  const statCats = ['PASSING', 'RUSHING', 'RECEIVING', 'DEFENSE', 'BLOCKING', 'KICKING'];
  const [selectedCategory, setSelectedCategory] = useState('PASSING');

  const formatValue = (val) => {
    if (val === null || val === undefined) return '-';
    if (typeof val === 'number') return val.toFixed(2);
    if (typeof val === 'object') return getStringValue(val);
    return val;
  };

  const getStatKeys = () => {
    const excluded = new Set(['TEAM', 'team', 'PLAYER_COUNT', 'NAME', 'name', 'POS', 'pos']);
    const keys = new Set();
    const t1Data = t1Stats[selectedCategory];
    const t2Data = t2Stats[selectedCategory];
    
    if (t1Data && typeof t1Data === 'object') {
      Object.keys(t1Data).forEach(k => {
        if (!excluded.has(k)) keys.add(k);
      });
    }
    if (t2Data && typeof t2Data === 'object') {
      Object.keys(t2Data).forEach(k => {
        if (!excluded.has(k)) keys.add(k);
      });
    }
    return Array.from(keys).sort();
  };

  const hasCategory = (cat) => {
    return (t1Stats[cat] && typeof t1Stats[cat] === 'object') || 
           (t2Stats[cat] && typeof t2Stats[cat] === 'object');
  };

  const availableCategories = statCats.filter(hasCategory);

  if (Object.keys(t1Stats).length === 0 && Object.keys(t2Stats).length === 0) {
    return null;
  }

  const t1Data = t1Stats[selectedCategory];
  const t2Data = t2Stats[selectedCategory];
  const statKeys = getStatKeys();

  return (
    <div style={{ marginBottom: '2rem' }}>
      <h3 style={{ textAlign: 'center', margin: '1rem 0' }}>
        {getStringValue(block.team1_name)} vs {getStringValue(block.team2_name)}
      </h3>

      {availableCategories.length > 0 && (
        <div style={{ display: 'flex', backgroundColor: '#003366', gap: 0, marginBottom: '1rem', overflowX: 'auto' }}>
          {availableCategories.map((cat) => (
            <button
              key={cat}
              onClick={() => setSelectedCategory(cat)}
              style={{
                flex: '1',
                padding: '0.75rem',
                backgroundColor: selectedCategory === cat ? '#003366' : '#003366',
                color: selectedCategory === cat ? '#fff' : '#ccc',
                border: 'none',
                cursor: 'pointer',
                fontSize: '0.9rem',
                fontWeight: selectedCategory === cat ? 'bold' : 'normal',
                borderBottom: selectedCategory === cat ? '3px solid #00ff00' : 'none',
                transition: 'all 0.2s ease',
              }}
            >
              {cat}
            </button>
          ))}
        </div>
      )}

      {statKeys.length > 0 && (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ backgroundColor: '#003366', color: 'white' }}>
                <th style={{ padding: '0.75rem', textAlign: 'left', borderBottom: '2px solid #003366' }}>
                  Stat
                </th>
                <th style={{ padding: '0.75rem', textAlign: 'left', borderBottom: '2px solid #003366' }}>
                  {getStringValue(block.team1_name)}
                </th>
                <th style={{ padding: '0.75rem', textAlign: 'right', borderBottom: '2px solid #003366' }}>
                  {getStringValue(block.team2_name)}
                </th>
              </tr>
            </thead>
            <tbody>
              {statKeys.map((statKey) => {
                const v1 = t1Data?.[statKey];
                const v2 = t2Data?.[statKey];
                const n1 = parseFloat(v1);
                const n2 = parseFloat(v2);
                const isT1Higher = !isNaN(n1) && !isNaN(n2) && n1 > n2;
                const isT2Higher = !isNaN(n1) && !isNaN(n2) && n2 > n1;

                return (
                  <tr key={statKey} style={{ borderBottom: '1px solid #eee' }}>
                    <td style={{ padding: '0.75rem', textAlign: 'left', fontSize: '0.85rem', color: '#666' }}>
                      {statKey}
                    </td>
                    <td
                      style={{
                        padding: '0.75rem',
                        textAlign: 'left',
                        fontWeight: isT1Higher ? 'bold' : 'normal',
                        color: isT1Higher ? '#003366' : 'inherit',
                      }}
                    >
                      {formatValue(v1)}
                    </td>
                    <td
                      style={{
                        padding: '0.75rem',
                        textAlign: 'right',
                        fontWeight: isT2Higher ? 'bold' : 'normal',
                        color: isT2Higher ? '#003366' : 'inherit',
                      }}
                    >
                      {formatValue(v2)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default TeamComparisonDisplay;
